import TypeHelper from './TypeHelper';
import General from '../constants/General';

export default {
    isNotNull(value)
    {
        return value !== null && value !== undefined && value !== '' || 'Bitte Feld ausfüllen';
    },
    isEmail(value)
    {
        return General.EMAIL_REGEX.test(value) || 'Bitte gültige E-Mail Adresse eingeben';
    },
    isNationalPhone(value)
    {
        return General.PHONE_REGEX.test(value) || 'Bitte eine gültige Telefonnummer eingeben';
    },
    runValidation(value, validators)
    {
        let validationResult = null;
        for (let i = 0; i < validators.length; i++)
        {
            let validatorResult = validators[i](value);
            validationResult = validatorResult === true ? null : validatorResult;

            //Stop validation when one validator returns errorMessage
            if (TypeHelper.isNotNullOrUndefined(validationResult))
                break;
        }

        return validationResult;
    }
}
